// extracted by mini-css-extract-plugin
module.exports =  {"layout":"a10a3f92e9--layout--B5Yrh","text":"a10a3f92e9--text--P7YwX","img":"a10a3f92e9--img--luR0a"};